import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
  className?: string;
  showText?: boolean;
}

const LoadingSpinner = ({ className, showText = false }: LoadingSpinnerProps) => {
  return (
    <div className={cn("flex flex-col items-center gap-4", className)}>
      <div className="animate-spin rounded-full h-12 w-12 border-[5px] border-gray-500 border-l-transparent" />
      {showText && <p className="text-gray-700">Now Loading</p>}
    </div>
  );
};

export default LoadingSpinner;
